export default {
  'Import users': 'Gebruikers importeren',
  'Imported users successfully': 'Gebruiker succesvol geimporteerd',
  'The users have been imported successfully.': 'De gebruikers zijn succesvol geimporteerd.',
  'Invited user successfully': 'Gebruiker succesvol uitgenodigd',
  'The invitation has been send successfully to the user.': 'De uitnodiging is met succes verzonden naar de gebruiker.',
  'Has files': 'Bestanden',
}
